import { render } from "./valid-election-receipt-alert.vue?vue&type=template&id=2766c20d"
import script from "./valid-election-receipt-alert.vue?vue&type=script&lang=js"
export * from "./valid-election-receipt-alert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__